import axios from "axios";
import { Base_URL } from "../url";

export const fetchExchangeRates = async () => {
  try {
    const response = await axios.get(`${Base_URL}/ExchangeRate/GetAllExchangeRates`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching exchange rates!";
  }
};

export const downloadExchangeRatesExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/ExchangeRate/DownloadExchangeRatesExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading exchange rates data!";
  }
};